// extracted by extract-css-chunks-webpack-plugin
module.exports = {"description":"info-personal-sumary-modal__description--q5iac"};